"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const fa_1 = require("react-icons/fa");
const options_1 = require("../options");
const ProgressIndicator_1 = __importDefault(require("./ProgressIndicator"));
const style = (0, react_1.css) `
  padding: 25px;
  border-radius: 10px;
  pointer-events: all;
  min-height: 60px;
  position: relative;

  > button {
    position: absolute;
    right: 5px;
    top: 5px;
    border: none;
    background-color: transparent;
    color: white;
  }
`;
function AlertBlock(props) {
    const { offset, alert, onClose } = props;
    return ((0, jsx_runtime_1.jsxs)("div", { css: style, style: {
            margin: offset,
            backgroundColor: alert.options.backgroundColor,
            color: alert.options.color,
        }, children: [(0, jsx_runtime_1.jsx)("button", { type: "button", onClick: onClose, children: (0, jsx_runtime_1.jsx)(fa_1.FaTimes, {}) }), (0, jsx_runtime_1.jsx)("span", { children: alert.message }), alert.options.type === options_1.types.PROGRESS_INDICATOR && (0, jsx_runtime_1.jsx)(ProgressIndicator_1.default, {})] }, alert.id));
}
exports.default = AlertBlock;
